import { Component, OnInit } from '@angular/core';
import { User } from './../../models/user';
import { VproService } from './../../service/vpro/vpro.service';
import { ActivatedRoute, Router } from '@angular/router';


import Swal from 'sweetalert2';

@Component({
  selector: 'app-set-new-pass',
  templateUrl: './set-new-pass.component.html',
  styleUrls: ['./set-new-pass.component.css']
})
export class SetNewPassComponent {
  user = new User();
  submitted = false;
  email_id: any;
  data: any;
  message: string;
  //editUser: string;

  // @SessionStorage() sessionValue = `I must be coming from Planet AWS you know ! `;

  constructor(private userSetPassService: VproService, private router: Router, private route: ActivatedRoute
  ) { }

  ngOnInit() {
    // this.user.email_id = localStorage.getItem('getUsr');
    const res = this.router.url;
    const lenurl = res.length;
    const uid = res.slice(21, lenurl);
    this.user.email_id = uid;
  }


  setUserPass(): void {
    this.submitted = true;
    // Shoot a mail to user
    if (this.user && this.user.email_id) {
      this.user.email_id = this.user.email_id.toLowerCase();
    }
    this.userSetPassService.setUserPass(this.user)
      .subscribe(result => this.message = "Password Updated Successfully!");
    // this.userSetPassService.mailUser(this.user).subscribe();

    // this.save();
    // SweetAlert
    Swal.fire({
      allowOutsideClick: false,
      position: 'top',
      type: 'success',
      title: 'New Password has been set, You can login with the new password ',
      showConfirmButton: false,
      timer: 2100
    });

  }
  // private save(): void {
  // //  localStorage.setItem('usethis', this.user.email_id);

  // }

}
